@let currentRoom = roomListAccessService.getCurrentModelRoom$() | async;
@let roomName = roomHelperService.getRoomname(currentRoom?.roomId, currentRoom?.name);
@if (currentRoom) {
  <mat-drawer-container style="background-color: inherit; height: 100%">
    <mat-drawer-content>
      <mat-card class="layout-container chat-container">
        <mat-card-header>
          <div class="avatar-wrapper">
            <button
              class="header-left avatar-button"
              [attr.data-testid]="testIds.buttonOpenProfileSettings"
              (click)="openDialog()"
              mat-card-avatar>
              @let roomAvatar = (userService.userCache | async)!.get(roomId()!);
              @if (roomAvatar) {
                <img class="avatar-icon" [src]="roomAvatar" alt="Avatar" />
              } @else {
                <mat-icon class="avatar-icon" color="primary" svgIcon="default-user-icon" />
              }
            </button>
            <!-- A_25562-01 - Hinweis auf Öffentlichkeit eines Raums -->
            @if (currentRoom.roomAccess === 'public') {
              <mat-icon
                color="primary"
                [matTooltip]="'Öffentlicher Chat:\nSichtbar und zugänglich für jeden'"
                svgIcon="globe"
                class="avatar-badge" />
            }
          </div>

          <mat-card-title-group class="header-title-group">
            <mat-card-subtitle>
              {{ getOtherRoomMembers(currentRoom?.members) }}
            </mat-card-subtitle>
            <mat-card-title>
              <div class="clamp-text">
                {{ roomName }}
              </div>
            </mat-card-title>
            <!-- A_25562-01 - Hinweis auf Öffentlichkeit eines Raums -->
            <div class="header-right">
              @if (!currentRoom.isEncrypted || currentRoom.historyVisibility === 'world_readable') {
                <span>
                  @if (!currentRoom.isEncrypted) {
                    <mat-icon color="warn" matTooltip="Unverschlüsselter Chat" svgIcon="lock_open" />
                  }
                  @if (currentRoom.historyVisibility === 'world_readable') {
                    <mat-icon
                      color="warn"
                      [matTooltip]="'Öffentliche Chathistorie:\nInhalte sind öffentlich einsehbar'"
                      svgIcon="triangle-exclamation" />
                  }
                </span>
              }
              <button
                mat-icon-button
                [attr.data-testid]="testIds.buttonOpenRoomInfo"
                [matTooltip]="isRoomInfoSidebarOpen ? 'Chat-Informationen schließen' : ' Chat-Informationen öffnen'"
                matTooltipPosition="below"
                (click)="toggleRoomInfoSidebar()"
                onKeyUp="toggleRoomInfoSidebar()"
                type="button">
                <mat-icon svgIcon="menu" />
              </button>
            </div>
          </mat-card-title-group>
        </mat-card-header>

        <mat-divider />

        <mat-card-content
          #container_chat
          class="message-list"
          (scroll)="scroll($event)"
          [attr.data-testid]="testIds.containerChat">
          <div id="scrollLast"></div>

          @let typing = typingUsers$ | async;
          @if (typing && typing.length > 0) {
            <div class="message-container typing-container">
              <app-sb-typing [typingUsers]="typing"></app-sb-typing>
            </div>
          }

          <app-message-stream [chatContainer]="container_chat" [readMarkerId]="readMarkerId" />
        </mat-card-content>

        <mat-card-footer>
          <div class="tiptap-div">
            <app-tiptap-editor [roomId]="currentRoom.roomId" [isEncrypted]="currentRoom.isEncrypted ?? false">
            </app-tiptap-editor>
          </div>
        </mat-card-footer>
      </mat-card>
    </mat-drawer-content>
    <mat-drawer [opened]="isRoomInfoSidebarOpen" position="end" mode="side" disableClose class="room-drawer">
      <app-sb-room-sidebar [opened]="isRoomInfoSidebarOpen" (sidebarOpenedChange)="toggleRoomInfoSidebar()" />

      <!--TODO Ändere mit app.routes.ts (so lange an dieser Stelle erforderlich)!-->
      <router-outlet />
    </mat-drawer>
  </mat-drawer-container>
}
